import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateContext } from "@insite/client-framework/Context";
import {
    chain,
    UpdateContext as DefaultUpdateContext,
    UpdateSession as DefaultUpdateSession,
} from "@insite/client-framework/Store/Context/Handlers/SetCurrentShipTo";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getSession, Session, updateSession } from "@insite/client-framework/Services/SessionService";
import { promoteContextCookiesToSharedDomain } from "@tSurya/Handlers/SharedCookieContext";

// Enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

type SetCurrentShipToUpdateSessionProps = Parameters<typeof DefaultUpdateSession>[0];

const UpdateSession: typeof DefaultUpdateSession = async (props: SetCurrentShipToUpdateSessionProps) => {
    await updateSession(props.apiParameter);

    const desiredShipToId = `${props.parameter.shipToId}`;
    const maxAttempts = 6;
    const delayMs = 200;

    let session: Session = (await getSession({})) as Session;
    for (let attempt = 0; attempt < maxAttempts && session.shipToId !== desiredShipToId; attempt++) {
        await new Promise<void>(resolve => {
            setTimeout(resolve, delayMs);
        });
        session = (await getSession({})) as Session;
    }

    if (session.shipToId !== desiredShipToId) {
        session.shipToId = desiredShipToId;
    }

    props.apiResult = session;
};

replaceInChain(chain, DefaultUpdateSession, UpdateSession);

const UpdateContextShared: typeof DefaultUpdateContext = props => {
    updateContext({
        shipToId: props.parameter.shipToId,
        settings: getSettingsCollection(props.getState()),
    });
    promoteContextCookiesToSharedDomain();
};

replaceInChain(chain, DefaultUpdateContext, UpdateContextShared);
